import React, { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import Banner from "../components/Banner";
import Lease from "../components/Lease";
import Offices from "../components/Offices";
import Map from "../components/Map";
import Vision from "../components/Vision";
import Perspective from "../components/Perspective";
import { usaStates } from "./PortfolioPage";
import {Helmet} from "react-helmet";
import {absoluteUrl} from "../components/Utils";
import useBestLocation from "../hooks/useBestLocation";

const LandingPage = () => {
  const [properties, setProperties] = useState(null);

  const locationData = useBestLocation();

  console.log("locationData",locationData);
  const location =  locationData && locationData.region ? `${locationData.city}, ${locationData.region}` : ""
  const latlng = locationData && locationData.latlng ? locationData.latlng : "";




const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in kilometers
    return (distance <= 800) ? true : false;
}



  // Load properties for that state
  useEffect(() => {
    const checkState = (stateProperty) => {
      const stateGet = (usaStates.find(s => s.name === locationData?.region) || usaStates.find(s => s.code === locationData?.region));
      return (stateGet && stateGet.code) ? (stateProperty.state === (stateGet.code)) : false;
    };
    const fetchRandomProperty = () => {

      fetch("/available_ll.json", { mode: "cors" })
        .then((response) => response.json())
        .then(async (data) => {

          let props = [];
          let alldata = data;
          let getStateProperty = [];
          let newData = data.filter((stateProperty) => stateProperty.available === true);

          newData.forEach((stateProperty) => {

            if (checkState(stateProperty)) {

              getStateProperty.push(stateProperty);
            }
          });




          if (getStateProperty.length >= 3) {
            while (props.length < 3) {
              let randomIndex = Math.floor(Math.random() * getStateProperty.length);
              let randomProperty = getStateProperty[randomIndex];
              if (!props.includes(randomProperty) && (randomProperty.available === true)) {
                props.push(randomProperty);
              }
            }
          } else {

            let remainingProperties = 3 - getStateProperty.length;
            props = getStateProperty;

            if(remainingProperties && latlng){
              let latlngArr = latlng.split(",");

              for(let prp = 0; prp < alldata.length; prp++ ){

                let randomProperty = alldata[prp];
                if (!props.includes(randomProperty)  && (randomProperty.available === true)) {

                  if(calculateDistance( randomProperty.lat, randomProperty.lng, latlngArr[0], latlngArr[1])){

                    props.push(randomProperty);
                  }

                }
                  if(props.length >= 3)
                  break;
              }
              //  let randomIndex = Math.floor(Math.random() * alldata.length);
                //let randomProperty = alldata[randomIndex];
               // props.push(randomProperty);

           console.log("props.length", props.length);

            if(props.length < 3){

              while (props.length < 3) {
                let randomIndex = Math.floor(Math.random() * alldata.length);
                let randomProperty = alldata[randomIndex];
                if (!props.includes(randomProperty)  && (randomProperty.available === true)) {
                  props.push(randomProperty);
                }
              }
            } }

          }
          console.log("props",props);

          // if (getStateProperty) {
          //   for (var init = 0; init < ((getStateProperty.length > 3) ? 3 : getStateProperty.length); init++) {
          //     let random = Math.floor(Math.random() * ((getStateProperty.length - 1) - 0 + 1) + 0);
          //     props.push(getStateProperty[random]);
          //   }
          // }
          setProperties(props);
        })
        .catch((error) => console.error(error));
    }

    fetchRandomProperty();

  }, [locationData?.region]);

  return (
      <>
          <Helmet>
              {/* This should get title and description from the Helmet in App.js */}
              <link rel="canonical" href={ absoluteUrl("/")} />
          </Helmet>
    <Box>
      <Banner location={location} properties={properties} />
      <Lease />
      <Offices location={location} />
      <Map location={location} city={(locationData && locationData.city) ? locationData.city : ""} />
      <Vision />
      <Perspective />
    </Box>
      </>
  );
};

export default LandingPage;
